import type { FC } from "react";
import { useState } from "react";

import { Modal } from "@Components/Modal";
import type { QueryXsMax } from "@stylex/tokens.stylex";
import * as stylex from "@stylexjs/stylex";

import type { IComponent } from "../Component";

const xsMax: QueryXsMax = "@media (max-width: 759px)";

const styles = stylex.create({
    container: {
        fontSize: "0.875rem",

        position: "relative",
        textAlign: "center",
        maxWidth: {
            default: "300px",
            [xsMax]: "100%",
        },
    },
});

export interface IErrorMessage {
    message: string;
    errorName?: string;
    isOpen?: boolean;
    onClose?: () => boolean | void;
}

export type IErrorMessageComponent = IErrorMessage & IComponent;

export const ErrorMessage: FC<IErrorMessageComponent> = (props) => {
    const [isOpen, setIsOpen] = useState(props.isOpen || false);

    return (
        <Modal
            key={props.errorName}
            clientId="modal-error"
            isOpen={isOpen}
            onClose={() => {
                if (!props.onClose || props.onClose() !== false) {
                    setIsOpen(false);
                }
            }}
            closeOnBlur={false}
        >
            <div {...stylex.props(styles.container)}>
                <div dangerouslySetInnerHTML={{ __html: props.message }} />
            </div>
        </Modal>
    );
};
